(ns pfo.valid
  (:require
   [clojure.string :as str]
   [pfo.util :as util]))

(def error-messages
  {:RequiredError "This field is required"})

(defn field-errors [response-obj]
  (assoc (into {} (map (fn [[field errors]]
                         [field
                          (str (str/join
                                 ". "
                                 (map
                                   #(get error-messages (keyword (:type %)) (:message %))
                                   errors))
                            ".")])
                    (get-in response-obj [:data :field_errors] {})))
    :__meta__ (get-in response-obj [:data :field_errors_data])))

(defn validate-with-list
  "Returns obj if it can be found in the provided collection. List items are processed through list-item-mapper, if present.
  Otherwise, returns nil."
  ([obj coll list-item-mapper]
   (when (util/in? (map list-item-mapper coll) obj)
     obj))
  ([obj coll] (validate-with-list obj coll identity)))
